import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WizardIdEnum } from "@app/core/model/enum/wizard-id.enum";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
/**
 * Service pour interagir avec l'API des wizards d'utilisateur
 */
export class UserWizardApiService {
    private readonly baseUrl = `${environment.baseApiUrl}/UserWizard`;

    constructor(private http: HttpClient) { }

    /**
     * Récupère la liste des wizards d'utilisateur
     */
    getUserWizards(): Observable<WizardIdEnum[]> {
        return this.http.get<WizardIdEnum[]>(this.baseUrl);
    }

    /**
     * Marque un wizard comme vu
     */
    markWizardAsSeen(wizardId: WizardIdEnum): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/${wizardId}`, {});
    }

    /**
     * Supprime un wizard d'utilisateur
     */
    deleteUserWizard(wizardId: WizardIdEnum): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${wizardId}`);
    }

    /**
     * Supprime tous les wizards d'utilisateur
     */
    deleteAllUserWizards(): Observable<void> {
        return this.http.delete<void>(this.baseUrl);
    }
}